import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  fallback:false,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/pages/Home/index.vue')
    },
    {
      path: '/eguarantee',
      name: 'HelloWorld',
      component: () => import('@/views/pages/index.vue')
    },
    {
      path: '/eguarantee/:id',
      name: 'HelloWorld',
      component: () => import('@/views/pages/index.vue')
    },
    {
      path: '/eguarante',
      name: 'HelloWorld',
      component: () => import('@/views/pages/index.vue')
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/views/pages/error-page/404.vue')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js